const theme = Object.freeze({
    dark: {
        primary: 'black',
        secondary: '',
        textColor: 'white'
    },
    light: {
        primary: 'white',
        secondary: '',
        textColor: 'black'
    }

})
export default theme